// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025

// Verion : 0.0.2
// LastEdit : AGALYA
// Last ADD : INITIAL STATE CHANGED AND ADDED COMMENTS
// MODFIED DATA : 28-02-2026

import AccuredInterestReportTypes from './accured-interest-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	fetchAccuredInterestDetailResponse: null,
	fetchAccuredInterestDetailArr: [],
};

const accuredInterestReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** FETCH AccuredInterest DETAILS START *********************** */
		case AccuredInterestReportTypes.FETCH_ACCURED_INTEREST_REPORT_SUCCESS:
			return {
				...state,
				fetchAccuredInterestDetailResponse: action.payload,
				fetchAccuredInterestDetailArr: docodeHexResponse(
					action.payload,
					'GetAccuredInterestReportDetailsKey',
				),
			};

		case AccuredInterestReportTypes.FETCH_ACCURED_INTEREST_REPORT_FAILURE:
			return { ...state, fetchAccuredInterestDetailResponse: action.payload };

		case AccuredInterestReportTypes.FETCH_ACCURED_INTEREST_REPORT_RESPONSE_CHANGED:
			return { ...state, fetchAccuredInterestDetailResponse: null };
		/** ***************** FETCH AccuredInterest DETAILS END *********************** */
		default:
			return state;
	}
};

export default accuredInterestReportReducer;
